import * as Yup from 'yup';

const schema = Yup.object().shape({
    tipoOrigem: Yup.string().required('Selecione uma opção'),
    nome: Yup.string().required('Campo obrigatório')
});

export default schema;